// import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";
import { initColorUtilities } from "./lib/color-utilities.js";
import { initScrollFunctions, getScroll } from "./lib/scroll";
import { initButtons } from "./lib/buttons.js";
import { initSlideshows } from "./lib/slideshows.js";
import { initModals } from "./lib/modals.js";
import { initLoopFunctions } from "./lib/loop.js";
import { initAnimations } from "./lib/animations.js";
import { initHeader } from "./lib/header.js";
import { initThumbnails } from "./lib/thumbnails.js";
import { initPdfHandler } from "./lib/pdf-handler.js";

document.addEventListener("DOMContentLoaded", function () {
	initScrollFunctions();
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();
	initColorUtilities();
	initButtons();
	initSlideshows();
	initLoopFunctions();
	initModals();
	initAnimations();
	initHeader();
	initThumbnails();
	initPdfHandler();
	addAnimationClassToLogo();
});

const addAnimationClassToLogo = () => {
	const logo = document.querySelector(".logo");
	if (!logo) return;

	logo.classList.add("animate");
};
